interface UltimosVagasSectionProps {
  onScrollTo: (id: string) => void;
}

export default function UltimosVagasSection({ onScrollTo }: UltimosVagasSectionProps) {
  return (
    <section id="urgencia" className="py-14 sm:py-16 bg-gradient-to-b from-white to-gray-50 relative">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <div className="bg-black rounded-2xl p-8 sm:p-10 md:p-12 text-center relative overflow-hidden">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-yellow-500 to-yellow-600"></div>
          <div className="absolute -top-10 -right-10 w-40 h-40 bg-yellow-500/5 rounded-full"></div>
          <div className="absolute -bottom-10 -left-10 w-32 h-32 bg-yellow-500/5 rounded-full"></div>

          <div className="relative z-10">
            <div className="w-14 h-14 sm:w-16 sm:h-16 bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-full flex items-center justify-center mx-auto mb-5">
              <i className="ri-alarm-warning-fill text-2xl sm:text-3xl text-black"></i>
            </div>
            <h4 className="text-2xl sm:text-3xl md:text-4xl font-black text-white mb-4">
              <a href="#urgencia">
                Não Perca Essa{' '}
                <span className="text-yellow-500">Oportunidade</span>
              </a>
            </h4>

            <div className="space-y-3 mb-6 sm:mb-8 max-w-lg mx-auto">
              <p className="text-gray-300 text-sm sm:text-base flex items-center justify-center gap-2">
                <i className="ri-error-warning-fill text-yellow-500 flex-shrink-0"></i>
                As vagas são limitadas por horário.
              </p>
              <p className="text-gray-300 text-sm sm:text-base flex items-center justify-center gap-2">
                <i className="ri-error-warning-fill text-yellow-500 flex-shrink-0"></i>
                As inscrições podem encerrar antes da data.
              </p>
              <p className="text-gray-300 text-sm sm:text-base flex items-center justify-center gap-2">
                <i className="ri-error-warning-fill text-yellow-500 flex-shrink-0"></i>
                Evento presencial — 19/04 em Campo Grande.
              </p>
            </div>

            <button
              onClick={() => onScrollTo('inscricao')}
              className="bg-gradient-to-r from-yellow-500 to-yellow-600 text-black px-8 sm:px-10 py-3.5 sm:py-4 rounded-full text-sm sm:text-base font-black hover:from-yellow-400 hover:to-yellow-500 transition-all duration-300 shadow-xl hover:shadow-yellow-500/30 hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              GARANTA SUA VAGA AGORA
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
